/* TIGHTKNIT — Home page interactivity
   - Variant lookup on shade/size/pack change (live price + ATC label)
   - UI exclusive selection
   - Sticky CTA on scroll
   - FAQ exclusive accordion
   - Image gallery thumb switching
   - Shade label live update
*/
(function () {
  "use strict";

  var product = null;
  var jsonNode = document.getElementById("home-product-json");
  if (jsonNode) {
    try { product = JSON.parse(jsonNode.textContent); } catch (e) { product = null; }
  }

  function $(s, root) { return (root || document).querySelector(s); }
  function $$(s, root) { return Array.prototype.slice.call((root || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    if (typeof cents !== "number") return "";
    var dollars = cents / 100;
    if (dollars % 1 === 0) return "$" + dollars.toFixed(0);
    return "$" + dollars.toFixed(2);
  }

  /* ---- Vendor-neutral CTA tracking ---- */
  function willaEvent(name, detail) {
    try { document.dispatchEvent(new CustomEvent("willa:" + name, { detail: detail })); } catch (e) { /* noop */ }
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".btn--solid, .btn--pink, .btn--cream, .nav__cta");
    if (!btn) return;
    var label = (btn.textContent || "").trim().slice(0, 80);
    var target = btn.getAttribute("href") || btn.getAttribute("data-target") || "";
    willaEvent("cta_click", { label: label, target: target, location: btn.closest("section") ? btn.closest("section").className : "" });
  });

  /* Sticky CTA scroll handling now lives in assets/sticky-cta.js (loaded site-wide via theme.liquid). */

  /* ---- Helper: exclusive selection within a group ---- */
  function setupExclusive(selector, selectedClass) {
    var nodes = $$(selector);
    nodes.forEach(function (el) {
      el.addEventListener("click", function () {
        nodes.forEach(function (n) { n.classList.remove(selectedClass); });
        el.classList.add(selectedClass);
      });
    });
  }
  setupExclusive(".swatch-circle", "swatch-circle--selected");
  setupExclusive(".size-square", "size-square--selected");
  setupExclusive(".bundle-row", "bundle-row--selected");
  setupExclusive(".pdp__thumb", "pdp__thumb--active");

  /* ---- Image gallery ---- */
  var pdpMain = $(".pdp__main");
  $$(".pdp__thumb").forEach(function (t) {
    t.addEventListener("click", function () {
      var img = t.dataset.img;
      if (pdpMain && img) pdpMain.style.backgroundImage = "url('" + img + "')";
    });
  });

  /* ---- Shade label live update + gallery repaint ---- */
  var shadeCurrent = $(".selector__current");
  var gallery = $(".pdp__gallery");
  var shadeImages = null;
  if (gallery && gallery.dataset.shadeImages) {
    try { shadeImages = JSON.parse(gallery.dataset.shadeImages); } catch (e) { shadeImages = null; }
  }
  function repaintGalleryForShade(color) {
    if (!shadeImages || !color) return;
    var key = String(color).toLowerCase();
    var imgs = null;
    if (key.indexOf("nude") >= 0) imgs = shadeImages.nude;
    else if (key.indexOf("tan") >= 0) imgs = shadeImages.tan;
    else imgs = shadeImages.black;
    if (!imgs || !imgs.length) return;
    var thumbs = $$(".pdp__thumb");
    thumbs.forEach(function (t, i) {
      var url = imgs[i] || imgs[0];
      t.dataset.img = url;
      t.style.backgroundImage = "url('" + url + "')";
      t.classList.toggle("pdp__thumb--active", i === 0);
    });
    if (pdpMain) pdpMain.style.backgroundImage = "url('" + imgs[0] + "')";
  }
  $$(".swatch-circle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var color = btn.dataset.color;
      if (shadeCurrent && color) shadeCurrent.textContent = color;
      repaintGalleryForShade(color);
    });
  });

  /* ---- FAQ exclusive accordion ---- */
  $$(".faq__item").forEach(function (item) {
    item.addEventListener("toggle", function () {
      if (item.open) {
        $$(".faq__item").forEach(function (other) { if (other !== item) other.open = false; });
      }
    });
  });

  /* ---- Variant resolver ---- */
  if (!product || !product.variants) return;

  var form = document.getElementById("home-product-form");
  if (!form) return;

  var idInput = document.getElementById("home-variant-id");
  var atcPrice = document.getElementById("home-atc-price");
  var atcBtn = document.getElementById("home-atc");

  function readSelectedOptions() {
    var labels = $$("[data-option-name]");
    var selected = {};
    labels.forEach(function (label) {
      var input = label.querySelector("input[type=radio]");
      if (input && input.checked) {
        selected[label.dataset.optionName] = input.value;
      }
    });
    return selected;
  }

  function findVariant(selected) {
    var optionNames = product.options.map(function (o) {
      return typeof o === "string" ? o : o.name;
    });
    return product.variants.find(function (v) {
      return optionNames.every(function (name, i) {
        var key = "option" + (i + 1);
        return v[key] === selected[name];
      });
    });
  }

  function updateForVariant(variant, selected) {
    if (!variant) {
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = "Unavailable";
      }
      return;
    }
    if (atcBtn) atcBtn.disabled = false;
    if (idInput) idInput.value = variant.id;
    if (atcPrice) atcPrice.textContent = formatMoney(variant.price);

    /* update bundle row prices to match each Pack value (other options held to current selection) */
    var packOptIdx = (product.options || []).findIndex(function (o) {
      return (typeof o === "string" ? o : o.name) === "Pack";
    });
    if (packOptIdx > -1) {
      $$(".bundle-row").forEach(function (row) {
        var radio = row.querySelector("input[type=radio]");
        if (!radio) return;
        var packValue = radio.value;
        var matching = product.variants.find(function (v) {
          if (v["option" + (packOptIdx + 1)] !== packValue) return false;
          return (product.options || []).every(function (o, i) {
            var name = typeof o === "string" ? o : o.name;
            if (name === "Pack") return true;
            return v["option" + (i + 1)] === selected[name];
          });
        });
        var priceEl = row.querySelector(".bundle-row__price");
        if (priceEl && matching) priceEl.textContent = formatMoney(matching.price);
      });
    }
  }

  function reconcile() {
    var selected = readSelectedOptions();
    var variant = findVariant(selected);
    updateForVariant(variant, selected);
  }

  $$("input[type=radio]", form).forEach(function (r) {
    r.addEventListener("change", reconcile);
  });
  $$("[data-option-name]").forEach(function (label) {
    label.addEventListener("click", function () {
      var input = label.querySelector("input[type=radio]");
      if (input && !input.checked) { input.checked = true; reconcile(); }
    });
  });

  reconcile();

  /* ---- ATC: AJAX add → open cart drawer (no /cart redirect) ---- */
  function currentVariant() {
    return findVariant(readSelectedOptions());
  }

  function setBtnLabel(text) {
    if (!atcBtn) return;
    var priceSpan = atcBtn.querySelector("#home-atc-price");
    if (priceSpan) {
      atcBtn.dataset.origLabel = atcBtn.dataset.origLabel || atcBtn.innerHTML;
      atcBtn.textContent = text;
    } else {
      atcBtn.textContent = text;
    }
  }
  function restoreBtnLabel() {
    if (atcBtn && atcBtn.dataset.origLabel) {
      atcBtn.innerHTML = atcBtn.dataset.origLabel;
      reconcile();
    }
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var variant = currentVariant();
    if (!variant || !variant.available) return;
    /* Without this the button is never actually disabled — only its label
       changes — so a double-tap fired two /cart/add.js calls and added the
       item twice (and double-counted the add_to_cart event). Same guard the
       landing page already uses via [data-claim-cta] dataset.inflight. */
    if (form.dataset.inflight === "1") return;
    form.dataset.inflight = "1";
    if (atcBtn) atcBtn.disabled = true;
    setBtnLabel("Adding…");

    var qty = 1;
    var qtyInput = document.getElementById("home-quantity");
    if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;

    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("cart/add failed " + r.status);
        return r.json();
      })
      .then(function () {
        try {
          willaEvent("add_to_cart", {
            handle: product.handle,
            variant_id: variant.id,
            price: variant.price / 100,
            currency: "USD",
            quantity: qty,
            source: "home-pdp",
          });
        } catch (e) {}
        document.dispatchEvent(new CustomEvent("willa:cart_added"));
        setTimeout(restoreBtnLabel, 600);
      })
      .catch(function (err) {
        console.error("[home] add to cart failed", err);
        setBtnLabel("Try again");
        setTimeout(restoreBtnLabel, 1500);
      })
      .finally(function () {
        form.dataset.inflight = "";
        if (atcBtn) atcBtn.disabled = false;
      });
  });
})();
